import { FC } from "react";

import dynamic from "next/dynamic";

import { getLendingDataQuery } from "lib/sanity/queries";
import { getClient } from "lib/sanity/server";

import NextSectionAction from "components/next-section-action";
import { RankedTableDataProps } from "components/ranked-table/types";
import FinancingMadeSimple from "components/views/lendflo/financing-made-simple";
import NonIntegratedLenders from "components/views/lendflo/non-integrated-lenders";

import Page from "../../components/layout/page";
import MainHero from "../../components/views/lendflo/main-hero";

const DemoFormSection = dynamic(() => import("../../components/demo-form-section"));
const ExploreLenders = dynamic(() => import("../../components/views/lendflo/explore-lenders"));

const Lendflo: FC<RankedTableDataProps> = (props: RankedTableDataProps) => (
  <Page
    title="Solar Financing for Installers | Offer Loans, Leases & PPAs on Enerflo"
    description="Offer solar loans, leases, and PPAs to your customers through Enerflo. Access multiple lenders, close more deals, and manage everything in one place."
  >
    <MainHero />
    <ExploreLenders {...props} />
    <FinancingMadeSimple />
    <NonIntegratedLenders />
    <NextSectionAction
      buttonText="View Solar Financing Operating System (Native)"
      url="/features/solar-financing-operating-system"
      description="Go native with Enerflo"
    />
    <DemoFormSection />
  </Page>
);

export default Lendflo;

export async function getStaticProps(ctx) {
  const { preview = null } = ctx;

  const client = getClient(preview);
  let lendingData: RankedTableDataProps = {
    integratorsList: [],
    features: [],
  };

  try {
    lendingData = await client.fetch(getLendingDataQuery(preview));
  } catch (e) {
    console.error("Unable to fetch lending data", e);
  }

  return {
    props: {
      preview,
      ...lendingData,
    },
  };
}
